<template>
  <div>
    <Layout/>
    <h4>Diagnósticos</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencion.idAtencion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPersona" name="idPersona" v-model="datoAtencion.idPersona"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="persona" name="persona" v-model="datoAtencion.persona" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPersonaLOV"
                      title="Buscar Personas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idMedico" name="idMedico" v-model="datoAtencion.idMedico"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="medico" name="medico" v-model="datoAtencion.medico" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalMedicoLOV"
                      title="Buscar Médico">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idCita" name="idCita" v-model="datoAtencion.idCita"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idCita" class="form-label"> Cita</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="cita" name="cita" v-model="datoAtencion.cita" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalCitaLOV"
                      title="Buscar Citas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAtencion.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAtencion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoAtencion.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarAtencion" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtencion" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtencion" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdBiomAten</th>
          <th scope="col">IdAtencion</th>
          <th scope="col">IdBiometria</th>
          <th scope="col">Valor</th>
          <th scope="col">Estado</th>
          <th scope="col">BiometriaNombre</th>
          <th scope="col">AtencionFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="biomaten in datosPaginados" :key="biomaten.idBiomAten">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(biomaten.idBiomAten)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(biomaten.idBiomAten)" title="Editar">edit_square</i></td>
          <td>{{biomaten.idBiomAten}}</td>
          <td>{{biomaten.idAtencion}}</td>
          <td>{{biomaten.idBiometria}}</td>
          <td>{{biomaten.valor}}</td>
          <td>{{biomaten.estado}}</td>
          <td>{{biomaten.biometriaNombre}}</td>
          <td>{{getFormattedDate(biomaten.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAtencion(biomaten.idBiomAten)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idBiomAten" class="form-label">IdBiomAten</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idBiomAten" name="idBiomAten" v-model="datoBiomAten.idBiomAten" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoBiomAten.idAtencion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idBiometria" name="idBiometria" v-model="datoBiomAten.idBiometria"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idBiometria" class="form-label"> Biometria</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="biometria" name="biometria" v-model="datoBiomAten.biometria" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalBiometriaLOV"
                      title="Buscar Biometría">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="valor" class="form-label">Valor</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="valor" name="valor" v-model="datoBiomAten.valor" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarBiomAten" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditBiomAten" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Persona -->
    <PersonaLOV @DatosPersona="GetDataPersonaLOV($event)"/>
<!-- Lista de Valores: Medico -->
    <MedicoLOV @DatosMedico="GetDataMedicoLOV($event)"/>
<!-- Lista de Valores: Cita -->
    <CitaLOV @DatosCita="GetDataCitaLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: BiomAten -->
    <BiomAtenLOVdet @DatosBiomAten="GetDataBiomAtenLOVdet($event)"/>
<!-- Lista de Valores: Biometria -->
    <BiometriaLOVdet @DatosBiometria="GetDataBiometriaLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import PersonaLOV from '../../components/lovs/PersonaLOV.vue'
import MedicoLOV from '../../components/lovs/MedicoLOV.vue'
import CitaLOV from '../../components/lovs/CitaLOV.vue'
// Listas de valores master
// Listas de valores details
import BiomAtenLOVdet from '../../components/lovs/BiomAtenLOV.vue'
import BiometriaLOVdet from '../../components/lovs/BiometriaLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, PersonaLOV
, MedicoLOV
, CitaLOV
// Listas de valores master
// Listas de valores details
, BiomAtenLOVdet
, BiometriaLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      atencions : [],
      datoAtencion : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAtencion: '',
// Variables master
// Variables details
      biomatens : [],
      datoBiomAten : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idAtencion = this.$route.params.p_idatencion
    this.abrirEditar(this.p_idAtencion)
    this.getBiomAtens()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoAtencion.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.idCita === ''){
        swal("Error!", "El elemento idCita no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.observacion === ''){
        swal("Error!", "El elemento observacion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.fechaAct === ''){
        swal("Error!", "El elemento fechaAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAtencion.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarAtencion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atencions', this.datoAtencion)
          swal("Correcto!", "Atencion creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtencion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atencions', this.datoAtencion)
          swal("Correcto!", "Atencion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAtencion={}
      this.titulo   = 'Crear Diagnósticos'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAtencion){
      this.modalWindow = true
      if(idAtencion != null){    
           api.get('/vwatencions/'+idAtencion).then(resp=>{
          this.datoAtencion = resp.data;
           });
      }
      this.titulo   = 'Editar Diagnósticos'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAtencion(){
      this.$router.push('/Atencion')
    },
// Procedimientos master
// Procedimientos detalle
    async getBiomAtens() {
      const resp = await api.get('/biomatens')
      this.biomatens = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.biomatens.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwbiomatens/nombre/'+this.nombreBusqueda).then(response=>{
          this.biomatens=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.biomatens.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwbiomatens').then(response=>{
      this.biomatens=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.biomatens.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoBiomAten.idAtencion === ''){
        swal("Error!", "El elemento idAtencion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.idCita === ''){
        swal("Error!", "El elemento idCita no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.observacion === ''){
        swal("Error!", "El elemento observacion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.fechaAct === ''){
        swal("Error!", "El elemento fechaAct no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoBiomAten.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarBiomAten(){
      if(this.validarForm() === 1){
        try {
          this.datoBiomAten.idAtencion = this.datoAtencion.idAtencion;
          await api.post('/biomatens', this.datoBiomAten)
          this.getBiomAtens();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "BiomAten creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditBiomAten(){
      if(this.validarForm() === 1){
        try {
          await api.post('/biomatens', this.datoBiomAten)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "BiomAten creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoBiomAten={}
      this.titulo   = 'Crear Diagnósticos'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idBiomAten){
      this.modalWindow = true
      if(idBiomAten != null){    
           api.get('/vwbiomatens/'+idBiomAten).then(resp=>{
          this.datoBiomAten = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Diagnósticos'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idBiomAten){
      this.modalWindow = true
      if(idBiomAten != null){
        this.$router.push('/biomatenmd/'+idBiomAten)
      }
    },
    async deleteBiomAten (idBiomAten) {
      try{
        await api.delete('/biomatens/'+idBiomAten)
          this.getBiomAtens()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataPersonaLOV(data) {
      this.datoAtencion.idPersona = data.idPersona;
      this.datoAtencion.persona = data.nombre;
    },
//    Lista de Valores
    GetDataMedicoLOV(data) {
      this.datoAtencion.idMedico = data.idMedico;
      this.datoAtencion.medico = data.nombre;
    },
//    Lista de Valores
    GetDataCitaLOV(data) {
      this.datoAtencion.idCita = data.idCita;
      this.datoAtencion.cita = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataBiomAtenLOVdet(data) {
      this.datoBiomAten.idBiomAten = data.idBiomAten;
      this.datoBiomAten.biomAten = data.nombre;
    },
//    Lista de Valores
    GetDataBiometriaLOVdet(data) {
      this.datoBiomAten.idBiometria = data.idBiometria;
      this.datoBiomAten.biometria = data.nombre;
    },
// Listas de valores details
  },
}
</script>
